import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownList(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownList',
    baseStyle: {
      border: `1px solid ${theme.colors.border15}`,
      borderRadius: theme.sizes['-4'],
      color: theme.colors.text
    }
  };
}
